module.exports = __webpack_public_path__ + "static/media/Tommy_Kevin.313437dd.jpg";